import { useLeadGeneratorChatCleanup } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/lead-generator/hooks";
import { useLeadsFiltersTrackingServiceSync } from "app/pages/sales-intelligence/modules/leads-search-filters/hooks/useLeadsFiltersTrackingServiceSync";
import useLeadsDescriptionQuery from "app/pages/sales-intelligence/modules/leads-search-filters/queries/useLeadsDescriptionQuery";
import { useSavedSearch } from "app/pages/sales-intelligence/pages/advanced-search/hooks";
import { useIsNewOnlyFilter } from "app/pages/sales-intelligence/pages/advanced-search/hooks/useIsNewOnlyFilter";
import { useIsShowSavedSearchListPanel } from "app/pages/sales-intelligence/pages/advanced-search/hooks/useIsShowListPanel";
import useLeadsSearchResultsQueries from "app/pages/sales-intelligence/pages/advanced-search/query/queries/useLeadsSearchResultsQueries";
import type { PageTabsConfig } from "app/pages/sales-intelligence/pages/advanced-search/types/page-tabs";
import { useContactSearchResult } from "app/pages/sales-intelligence/sub-modules/contacts-search/hooks/useContactSearchResult";
import { useContactsStatusEffect } from "app/pages/sales-intelligence/sub-modules/contacts-search/hooks/useContactsStatusEffect";
import { useGetAllContactProfilesQuery } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/queries/useGetAllContactProfilesQuery";

const useTabsData = (tabsConfig: PageTabsConfig): void => {
    useLeadsDescriptionQuery();
    useSavedSearch();
    useGetAllContactProfilesQuery();

    useLeadsSearchResultsQueries(tabsConfig);

    useContactSearchResult(false);
    useContactsStatusEffect();

    useIsShowSavedSearchListPanel();
    useIsNewOnlyFilter();
    useLeadsFiltersTrackingServiceSync();

    useLeadGeneratorChatCleanup();
};

export default useTabsData;
